<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Draw name" style="text-align: left;">
          <b-input v-model="name" v-focus placeholder="Draw name" required></b-input>
        </b-field>

          <b-field label="Draw format" style="text-align: left;">
            <b-select v-model="format" placeholder="Select..." expanded required>
              <option value="elimination">Elimination</option>
              <option value="round-robin">Round-robin</option>
            </b-select>
          </b-field>


          <b-field label="Draw stage" style="text-align: left;">
            <b-select v-model="stage" placeholder="Select..." expanded required>
              <option value="qualification">Qualification</option>
              <option value="main-draw">Main draw</option>
              <option value="consolation">Consolation</option>
            </b-select>
          </b-field>



          <b-field label="Draw size" style="text-align: left;" v-if="format == 'elimination'">
            <b-select v-model="size" placeholder="Select..." expanded required>
              <option :value="Math.pow(2, val)" v-for="val in 7">{{ Math.pow(2, val) }}</option>
            </b-select>
          </b-field>


          <b-tabs v-model="activeTab" style="margin-top: 45px;">


            <b-tab-item label="Players">
              <h3 style="font-weight: 600; font-size: 1rem; text-align: left; margin-top: 15px;">Players</h3>
              <b-table :data="event.entries" checkable :checked-rows.sync="drawEntries" v-if="event">
                <template slot-scope="props">
                  <b-table-column field="id" label="#">
                    {{ props.row.id }}
                  </b-table-column>

                  <b-table-column field="id" label="Entry">
                    <Entry :tournament="tournament" :event="event" :entry="props.row" :showMissing="true" />
                  </b-table-column>

                  <b-table-column field="id" label="Event">
                    {{ event.name }}
                  </b-table-column>

                </template>
              </b-table>
            </b-tab-item>



            <b-tab-item label="Contenders (Q)" v-if="event">

              <div v-for="d in event.draws" v-if="isPreviousDraw(d)">
                <p class="has-text-left is-size-5" style="margin-top: 20px;">{{d.name}}</p>

                <b-field><p class="control"><button @click="toggleContender(d, 1, 1)" class="button" :class="{'is-info': isContender(d, 1)}">1</button></p>
                <p class="control"><button @click="toggleContender(d, 2, 2)" class="button" :class="{'is-info': isContender(d, 2)}">2</button></p>
                <p class="control"><button @click="toggleContender(d, 3, 3)" class="button" :class="{'is-info': isContender(d, 3)}">3</button></p>
                <p class="control"><button @click="toggleContender(d, 4, 4)" class="button" :class="{'is-info': isContender(d, 4)}">4</button></p>
                <p class="control"><button @click="toggleContender(d, 5, 8)" class="button" :class="{'is-info': isContender(d, 5)}">5-8</button></p>
                <p class="control"><button @click="toggleContender(d, 9, 16)" class="button" :class="{'is-info': isContender(d, 9)}">9-16</button></p>
                <p class="control"><button @click="toggleContender(d, 17, 32)" class="button" :class="{'is-info': isContender(d, 17)}">17-32</button></p>
                <p class="control"><button @click="toggleContender(d, 33, 64)" class="button" :class="{'is-info': isContender(d, 33)}">33-64</button></p>
                <p class="control"><button @click="toggleContender(d, 65, 128)" class="button" :class="{'is-info': isContender(d, 65)}">65-128</button></p></b-field>

              </div>
            </b-tab-item>

          </b-tabs>





        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-danger" v-if="id" style="margin-top: 25px; margin-bottom: -10px; margin-right: 30px;" @click="deleteDraw">Delete</button>
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">Submit</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';

import Entry from "../components/Entry.vue";
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      name: '',
      format: 'elimination',

      size: 4,
      drawEntries: [],
      contenderEntries: [],
      stage: 'main-draw',

      activeTab: 0,
      submitInProgress: false,
      failedSubmit: false
    }
  },

  computed: {
    teams: function() {
      if (this.tournament) {
        return this.tournament.teams;
      }

      return [];
    },

    event: function() {
      let selected = null;
      if (this.tournament && this.tournament.events) {
        selected = this.tournament.events.filter(event => event.id == this.eventId);
        if (selected && selected.length > 0) {
          selected = selected[0];
        } else {
          selected = null;
        }
      }

      return selected;
    },
    eventId: function() { return this.$route.params.event; },
    id: function() { return this.$route.params.draw; },
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament && this.event && this.id) {
          let draw = this.event.draws.filter(draw => draw.id == this.id);
          if (draw && draw.length > 0) {
            this.name = draw[0].name;
            this.stage = draw[0].stage;
            this.format = draw[0].format;
            this.size = draw[0].size;

            this.drawEntries = this.event.entries.filter(e => {
              return draw[0].entries.filter(entry => typeof (entry) !== 'object' && entry == e.id).length > 0;
            });

            this.contenderEntries = draw[0].entries.map(e => {

              if (typeof (e) === 'object') {
                return e;
              }

              return undefined;
            }).filter(e => e);


            this.$forceUpdate();
          }
        }
      }
    }
  },

  methods: {
    deleteDraw: function() {
      let draw = this.event.draws.filter(draw => draw.id == this.id)[0];

      this.$dialog.confirm({
        message: 'Are you sure you want to delete this draw?\nThis action will only succeed if no other draws depend on it.',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('deleteItem', { type: 'draw', item: draw }); }
      });
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      let tournamentId = this.$route.params.id;
      let eventId = this.$route.params.event;

      let allEntries = this.drawEntries.map(entry => (entry.draw ? entry : entry.id));
      allEntries = allEntries.concat(this.contenderEntries.map(entry => (entry.draw ? entry : entry.id)));

      let drawId = this.id;

      axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/draws', {
        name: this.name,
        stage: this.stage,
        format: this.format,
        size: this.size,
        entries: allEntries,

        id: drawId
      })
        .then(function(response){
          vm.submitInProgress = false;
          vm.failedSubmit = false;

          vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, suggestedPage: '/tournaments/' + tournamentId + '/events/' + eventId + '/draws' });
        })
        .catch(function(){
          vm.submitInProgress = false;
          vm.failedSubmit = true;
        });
    },

    isPreviousDraw(draw) {

      if (!this.id) {
        switch (this.stage) {
          case 'main-draw': return draw.stage == 'qualification';
          case 'consolation': return draw.stage == 'main-draw';
        }

        return false;
      }

      let currentDraw = this.event.draws.filter(draw => draw.id == this.id);

      switch (currentDraw[0].stage) {
        case 'main-draw': return draw.stage == 'qualification';
        case 'consolation': return draw.stage == 'main-draw';
      }

      return false;
    },

    isContender(otherDraw, rank) {
      return this.contenderEntries.filter(entry => {
        return ((typeof(entry) === 'object') && entry.draw === otherDraw.id && entry.rank == rank);
      }).length > 0;
    },


    toggleContender(otherDraw, rankFrom, rankTo) {

      let toggleSingleContender = (otherDraw, rank) => {

        let filteredEntries = this.contenderEntries.filter(entry => {

          if ((typeof(entry) === 'object') && entry.draw == otherDraw.id && entry.rank == rank) {
            return false;
          }

          return true;
        });

        if (filteredEntries.length !== this.contenderEntries.length) {
          this.contenderEntries = filteredEntries;
        } else {
          this.contenderEntries.push({ draw: otherDraw.id, rank: rank });
        }

      };

      for (let rank=rankFrom; rank <= rankTo; rank++) {
        toggleSingleContender(otherDraw, rank);
      }
    }
  },

  name: 'edit-tournament-event-draws',
  components: { Entry },
}
</script>



<style scoped>

</style>